import MessageConfigTripGroupDropdown from './MessageConfigTripGroupDropdown';
export default MessageConfigTripGroupDropdown;
